"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWrapper = _interopRequireDefault(require("../withWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _withWrapper.default)('Drag', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M14 0H0V14H14V0Z",
    fill: "white",
    fillOpacity: "0.01"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54166 2.91667C5.54166 3.56099 5.01932 4.08333 4.37499 4.08333C3.73067 4.08333 3.20833 3.56099 3.20833 2.91667C3.20833 2.27233 3.73067 1.75 4.37499 1.75C5.01932 1.75 5.54166 2.27233 5.54166 2.91667ZM4.37499 8.16667C5.01932 8.16667 5.54166 7.64432 5.54166 7C5.54166 6.35568 5.01932 5.83333 4.37499 5.83333C3.73067 5.83333 3.20833 6.35568 3.20833 7C3.20833 7.64432 3.73067 8.16667 4.37499 8.16667ZM4.37499 12.25C5.01932 12.25 5.54166 11.7277 5.54166 11.0833C5.54166 10.439 5.01932 9.91667 4.37499 9.91667C3.73067 9.91667 3.20833 10.439 3.20833 11.0833C3.20833 11.7277 3.73067 12.25 4.37499 12.25Z",
    fill: "#338AFF"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7917 2.91667C10.7917 3.56099 10.2693 4.08333 9.62499 4.08333C8.98067 4.08333 8.45833 3.56099 8.45833 2.91667C8.45833 2.27233 8.98067 1.75 9.62499 1.75C10.2693 1.75 10.7917 2.27233 10.7917 2.91667ZM9.62499 8.16667C10.2693 8.16667 10.7917 7.64432 10.7917 7C10.7917 6.35568 10.2693 5.83333 9.62499 5.83333C8.98067 5.83333 8.45833 6.35568 8.45833 7C8.45833 7.64432 8.98067 8.16667 9.62499 8.16667ZM9.62499 12.25C10.2693 12.25 10.7917 11.7277 10.7917 11.0833C10.7917 10.439 10.2693 9.91667 9.62499 9.91667C8.98067 9.91667 8.45833 10.439 8.45833 11.0833C8.45833 11.7277 8.98067 12.25 9.62499 12.25Z",
    fill: "#338AFF"
  }));
});

exports.default = _default;